import React from 'react'
import { StyleSheet, View } from 'react-native'
import { Button } from '@ui-kitten/components'
import { useAtomValue } from 'jotai'
import { storesDictAtom, userRoleAtom, userStoreIdAtom } from '../global/AtomsProvider'
import { useTranslation } from 'react-i18next'

export default function StoreChooserHorizontal( { store, onChange, style, showAll=true, forceShowForSingleStoreOrgs=false } ) {
  const storesDict = useAtomValue(storesDictAtom)
  const userRole = useAtomValue(userRoleAtom)
  const userStoreId = useAtomValue(userStoreIdAtom)
  const { t } = useTranslation()

  if ((Object.keys(storesDict)?.length > 1
      && (userRole?.permissions?.['viewOtherStores'] || userRole?.id === 'admin'))
      || forceShowForSingleStoreOrgs) {
    return (
      <View style={[styles.storeChooser, style]}>
        { showAll && <Button appearance='outline' status={store === 'all' ? 'primary' : 'basic'} style={{marginBottom: 5}} onPress={() => {
          onChange('all')
        }}>{t('all')}</Button> }
        { Object.entries(storesDict).map(([key, value]) => (
          ((forceShowForSingleStoreOrgs && key === userStoreId) || (userRole?.permissions?.['viewOtherStores'] || userRole?.id === 'admin')) &&
          <Button style={styles.storeButton} key={key} appearance='outline' status={store === key ? 'primary' : 'basic'} onPress={() => {
            onChange(key)
          }}>{value.name}</Button>
        ))}
      </View>
    )
  } else {
    return null
  }
}

const styles = StyleSheet.create({
  storeChooser: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: 5
  }, 
  storeButton: {
    marginLeft: 5,
    marginBottom: 5
  }
})
